import axios from "axios";
import constants from "../constants";
import qs from "qs";
// import $ from 'jquery';

export default {

  initConfig: function (config) {
    !config && (config = {});
    !config.paramsSerializer &&
    (config.paramsSerializer = function (params) {
      return qs.stringify(params, {
        arrayFormat: "repeat"
      });
    });
    !config.baseURL && (config.baseURL = constants.SIGN_TOKEN_BASE_SERVICE_URL);
    !config.headers && (config.headers = {});
    !config.timeout && (config.timeout = constants.AXIOS_REQUEST_TIMEOUT * 1000);
    let header = config.headers;
    !header["Content-Type"] && (header["Content-Type"] = "application/json");
    console.log(JSON.stringify(config));
    return config;
  },

  get(url, config) {
    config = this.initConfig(config);
    return axios.get(url, config);
  },

  post(url, data, config) {
    config = this.initConfig(config);
    return axios.post(url, data, config);
  },

  getCert(mst) {
    return this.get("mobi/getcert", {params: {mst: mst}});
  },

  signPdf(cert, base64String) {
    let infoSign = {fileData: base64String, certSerial: cert.Serial, signDate: null, typeSign: "1"};
    return this.signPdfV2(infoSign);
  },

  signPdfV2(infoSign) {

    // $.ajax({
    //   type: 'POST',
    //   data: JSON.stringify(infoSign),
    //   contentType: "application/json",
    //   url: constants.SIGN_TOKEN_BASE_SERVICE_URL + "mobi/signpdf"
    // }).done(function (result) {
    //   console.log(result.Status);
    //   console.log(result.ErrorDetail);
    // });
    // return null;
    // console.log(JSON.stringify(infoSign));
    return this.post("signHash", infoSign);
  },
}



// WEBPACK FOOTER //
// ./src/services/signTokenService.js